import { FC } from "react";
import { Box, Flex, Stack, SystemProps, Text } from "@storyofams/react-ui";
import { ProductByHandleQuery } from "~lib/shopify/sdk";
import { Label } from "../Label";
import { SingleVariant } from "../SingleVariant";
interface OptionProps extends SystemProps {
  title: string;
  options: ProductByHandleQuery["productByHandle"]["variants"]["edges"][0]["node"][];
  isOpen: boolean;
  onClick: (e) => void;
  mostPopularVariant?: string;
  autoDiscount: string | null;
}

export const Variant: FC<OptionProps> = ({
  title,
  options,
  isOpen,
  onClick,
  autoDiscount,
  mostPopularVariant,
  ...props
}) => {
  const isPopular = options.find((item) => item.id === mostPopularVariant);
  return (
    <Box width="100%" onClick={onClick} {...props}>
      <Box
        as="button"
        width={"100%"}
        py={["16px", "11px"]}
        px={["6px", "16px"]}
        border={isOpen ? "1px solid #1D1D1B" : "1px solid #E2DFDF"}
        borderRadius={"8px"}
      >
        <Box
          width={"100%"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"space-between"}
          mb={isOpen ? 1 : 0}
        >
          <Flex alignItems={"center"}>
            <Box
              width={16}
              border="1px solid black"
              height={16}
              borderRadius={"full"}
              display={"flex"}
              alignItems={"center"}
              flexShrink={1}
              justifyContent={"center"}
              mr={1}
            >
              {isOpen && (
                <Box
                  width={6}
                  border="1px solid black"
                  height={6}
                  backgroundColor={"black"}
                  borderRadius={"full"}
                />
              )}
            </Box>
            <Text
              textAlign={"start"}
              lineHeight={"22px"}
              fontSize={"16px"}
              fontWeight={600}
            >
              {title}
            </Text>
            {isPopular && !isOpen && <Label ml={[1, 1]} isOutOfStock={false} />}
          </Flex>

          <Text fontSize={"14px"} ml={1}>
            {options.length} varianten
          </Text>
        </Box>
        {isOpen && (
          <Stack space={1} flexDirection={"column"}>
            {options.map((item) => (
              <SingleVariant
                key={item.id}
                option={item}
                mostPopularVariant={mostPopularVariant}
                autoDiscount={autoDiscount}
              />
            ))}
          </Stack>
        )}
      </Box>
    </Box>
  );
};
